{
  "commerce": {
    "aiChatView": {
      "errorPausedDetail": "AI je vključen v naročnino. Če se želite naročiti, odprite Nastavitve → Obračun."
    },
    "billingPage": {
      "title": "Obračun"
    },
    "paywallGate": {
      "errorOpenBilling": "Strani z naročnino ni bilo mogoče odpreti. Poskusite znova.",
      "lapsedDescription": "Obnovite naročnino in še naprej upravljajte svojo nastanitev: 30 € na enoto na mesec, AI je vključen.",
      "pastDue": "Plačilo ni uspelo. Posodobite način plačila, da ohranite dostop.",
      "startTrial": "Začnite {days}-dnevni brezplačni preizkus",
      "subscribe": "Naročite se",
      "subscribeDescription": "Brezplačni preizkus ste že izkoristili. Naročite se in še naprej upravljajte svojo nastanitev: 30 € na enoto na mesec, AI je vključen.",
      "subscribeTitle": "Naročite se na Vidimo",
      "trialAddPaymentMethod": "Dodajte način plačila, da ohranite dostop.",
      "trialDescription": "Preizkusite Vidimo {days} dni brezplačno, brez kartice. Nato 30 € na enoto na mesec, AI je vključen.",
      "trialTitle": "Začnite brezplačni preizkus"
    },
    "propertySettingsView": {
      "billingDescription": "Naročnina, poraba AI in način plačila",
      "billingTitle": "Obračun"
    },
    "subscriptionGate": {
      "aiIncluded": "Funkcije AI so vključene v naročnino.",
      "aiTitle": "AI",
      "errorGeneric": "Prišlo je do napake",
      "errorLoad": "Podatkov o naročnini ni bilo mogoče naložiti",
      "manageSubscription": "Upravljajte naročnino",
      "status": {
        "active": "Aktivna",
        "past_due": "Plačilo zamuja",
        "trialing": "Brezplačni preizkus"
      },
      "subscribe": "Naročite se",
      "subscribePrice": "30 € na enoto na mesec, obračunano glede na število enot v tej nastanitvi. Funkcije AI so vključene.",
      "subscribeTitle": "Naročnina",
      "subscribedPrice": "30 € na enoto na mesec. Ko dodate ali odstranite enoto, se znesek samodejno posodobi.",
      "subscriptionTitle": "Naročnina"
    }
  }
}
